import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { brand } from "../mock";

const PageHero = ({ eyebrow, title, subtitle, breadcrumb, compact = false }) => {
  return (
    <section className={`relative pt-[120px] bg-[#0B1B3B] text-white overflow-hidden ${compact ? "pb-8" : "pb-16"}`}>
      <div className="absolute inset-0 grid-lines-bg opacity-40" />
      <div
        className="absolute -top-20 -right-20 h-[260px] w-[260px] rounded-full orb sm:-top-24 sm:-right-24 sm:h-[500px] sm:w-[500px]"
        style={{ background: "radial-gradient(closest-side, rgba(30,86,227,0.28), transparent 70%)" }}
      />
      <div className="container-x relative">
        {breadcrumb && (
          <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-slate-400">
            {breadcrumb.map((b, i) => (
              <React.Fragment key={i}>
                {b.to ? (
                  <Link to={b.to} className="hover:text-white">{b.label}</Link>
                ) : (
                  <span className="text-white">{b.label}</span>
                )}
                {i < breadcrumb.length - 1 && <ArrowRight size={12} />}
              </React.Fragment>
            ))}
          </div>
        )}
        {eyebrow && (
          <span className="mt-4 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#7CA6FF] bg-white/5 border border-white/10 px-3 py-1.5 rounded-full">
            {eyebrow}
          </span>
        )}
        <h1 className="mt-5 text-3xl md:text-5xl font-extrabold leading-tight max-w-4xl">{title}</h1>
        {subtitle && <p className="mt-5 text-lg text-slate-300 max-w-3xl leading-relaxed">{subtitle}</p>}
        <div className="mt-8 flex flex-wrap gap-4">
          <Link
            to={brand.bookingPath}
            className="btn-primary"
            data-testid="pagehero-book-appointment-button"
          >
            Book Appointment <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PageHero;
